/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Week_Session_Stats_CompletedInputs */

const fr_week_session_stats_completed = /** @type {(inputs: Week_Session_Stats_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminées`)
};

/**

* @param {Week_Session_Stats_CompletedInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const week_session_stats_completed = /** @type {((inputs?: Week_Session_Stats_CompletedInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Week_Session_Stats_CompletedInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_week_session_stats_completed(inputs)
});